import React, { useState, useEffect } from "react";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import RORRecentActivity from "../CommonDashboard/ROR/RORRecentActivity";
import RORRushNotesSummary from "../CommonDashboard/ROR/RORRushNotesSummary";
import RORCaseActionSummary from "../CommonDashboard/ROR/RORCaseActionSummary";
import RORWorkloadBreakdown from "../CommonDashboard/ROR/RORWorkloadBreakdown";
import RORPageReviewSummary from "../CommonDashboard/ROR/RORPageReviewSummary";
import RORInvoiceOverview from "../CommonDashboard/ROR/RORInvoiceOverview";
import RORAppointmentSummary from "../CommonDashboard/ROR/RORAppointmentSummary";

interface RORSummaryTypeProps {
  onTabChange: () => void;
  userRole: string;
}

const RORSummaryType: React.FC<RORSummaryTypeProps> = ({
  onTabChange,
  userRole,
}) => {
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);
  const [showRushNotesSummary, setShowRushNotesSummary] = useState(false);

  return (
    <Container fluid className="px-4 dashboard">
      <Row>
        {!showRushNotesSummary ? (
          <Col md={3} className="latestcase d-flex align-items-stretch">
            <RORRecentActivity
              openDropdown={openDropdown}
              setOpenDropdown={setOpenDropdown}
              setShowRushNotesSummary={setShowRushNotesSummary}
              userRole={userRole}
            />
          </Col>
        ) : (
          <Col md={3} className="latestcase d-flex align-items-stretch">
            <RORRushNotesSummary
              openDropdown={openDropdown}
              setOpenDropdown={setOpenDropdown}
              setShowRushNotesSummary={setShowRushNotesSummary}
              userRole={userRole}
            />
          </Col>
        )}
        <Col md={6} className=" caseactions d-flex align-items-stretch">
          <RORCaseActionSummary
            onTabChange={onTabChange}
            openDropdown={openDropdown}
            setOpenDropdown={setOpenDropdown}
            userRole={userRole}
          />
        </Col>
        <Col md={3} className="appointments d-flex align-items-stretch">
          <RORAppointmentSummary />
        </Col>
      </Row>
      <Row className="mt-4 mb-4 case-summary align-items-stretch">
        <Col md={12}>
          <RORInvoiceOverview
            openDropdown={openDropdown}
            setOpenDropdown={setOpenDropdown}
            userRole={userRole}
          />
        </Col>
      </Row>
      <Row className="mt-4 mb-4 case-summary align-items-stretch">
        <Col md={6} className="d-flex">
          <RORWorkloadBreakdown
            openDropdown={openDropdown}
            setOpenDropdown={setOpenDropdown}
          />
        </Col>
        <Col md={6} className="d-flex">
          <RORPageReviewSummary
            openDropdown={openDropdown}
            setOpenDropdown={setOpenDropdown}
            userRole={userRole}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default RORSummaryType;
